module.exports = __webpack_public_path__ + "img/arrow.f317887c.svg";